import React from 'react';
import { AddToCompareBtn } from './srp-card-ui.styles';

function replaceCount(str, count) {
  return str.replace('{{count}}', count);
}

export default function AddToCompareFlightBtn({
  flightItem,
  isAdded,
  flightComparisonData,
  addOrRemoveToFlightsCompareList,
  isCoachMark = false
}) {
  const { selected = {}, unselected = {} } = flightComparisonData?.addToCompareButton || {};
  const [flightComparisonText, flightComparisonIcon] = [
    isAdded ? selected?.text : unselected?.text,
    isAdded ? selected?.icon : unselected?.icon
  ];

  return (
    <AddToCompareBtn
      className="dF addCompareBtns"
      style={isCoachMark ? { paddingLeft: '10px', paddingRight: '10px' } : {}}
    >
      <span
        className="pointer blueCnt font12 f500 dF alignItemsCenter"
        onClick={() => {
          addOrRemoveToFlightsCompareList(flightItem);
        }}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: flightComparisonText
          }}
        ></span>
        {flightComparisonIcon ? (
          <img className="marginL5 icon16" src={flightComparisonIcon} />
        ) : null}
      </span>
    </AddToCompareBtn>
  );
}
